import React from 'react';
const FilterLocation = props => <div className={props.className}>LocationFilter</div>;
export default FilterLocation;
